var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.258 19.784"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.667 3.09a3.54 3.54 0 0 0-2.5-2.5c-2.2-.591-11.04-.591-11.04-.591s-8.838 0-11.04.591a3.54 3.54 0 0 0-2.5 2.5 36.807 36.807 0 0 0-.59 6.8 36.8 36.8 0 0 0 .59 6.8 3.541 3.541 0 0 0 2.5 2.5c2.2.59 11.04.59 11.04.59s8.838 0 11.04-.59a3.541 3.541 0 0 0 2.5-2.5 36.806 36.806 0 0 0 .59-6.8 36.76 36.76 0 0 0-.59-6.8M11.3 14.13V5.653l7.342 4.24Z"
  })));
};
export default SvgIconYoutube;